import UserRow from "./userRow";

/**
 * Returns the User Table component.
 * 
 * @returns The User Table component.
 */
const UserTable = (props) => {
    // Sorting function
    const sortUsers = (a, b) => {
        if (props.sortBy === "alphabetical") {
            // Sort by username
            if (`${a.fname} ${a.lname}` < `${b.fname} ${b.lname}`) {
                return -1;
            }

            if (`${a.fname} ${a.lname}` > `${b.fname} ${b.lname}`) {
                return 1;
            }

            return 0;
        } else {
            // Sort by role
            if (a.role < b.role) {
                return -1;
            }

            if (a.role > b.role) {
                return 1;
            }

            return 0;
        }
    };

    return (
        <>
            <table className="w-full">
                <thead className="bg-gray-100">
                    <tr>
                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm sm:text-base font-semibold text-gray-900 sm:pl-6">
                            Name
                        </th>

                        <th
                            scope="col" className="hidden px-3 py-3.5 text-left text-sm sm:text-base font-semibold text-gray-900 sm:table-cell"
                        >
                            Email
                        </th>

                        <th scope="col" className="px-3 py-3.5 text-left text-sm sm:text-base font-semibold text-gray-900">
                            Role
                        </th>

                        <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                            <span className="sr-only">Action</span>
                        </th>
                    </tr>
                </thead>
                
                <tbody className="divide-y divide-gray-200 bg-white">
                    {props.rows.sort(sortUsers).map((user) => (
                        <UserRow
                            user={user}
                            key={user.username}
                            setShow={props.setShow}
                            selectedUserHandler={props.selectedUserHandler}
                        />
                    ))}
                </tbody>
            </table>
        </>
    );
}
 
export default UserTable;